import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const BASE = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api';

const COUNTRIES = [
  'Afghanistan','Albania','Algeria','Andorra','Angola','Argentina','Armenia','Australia','Austria','Azerbaijan',
  'Bahrain','Bangladesh','Belarus','Belgium','Belize','Benin','Bhutan','Bolivia','Bosnia','Botswana','Brazil',
  'Brunei','Bulgaria','Burkina Faso','Burundi','Cambodia','Cameroon','Canada','Cape Verde','Chad','Chile',
  'China','Colombia','Comoros','Congo','Costa Rica','Croatia','Cuba','Cyprus','Czech Republic','Denmark',
  'Djibouti','Dominican Republic','DR Congo','Ecuador','Egypt','El Salvador','Estonia','Ethiopia','Fiji',
  'Finland','France','Gabon','Gambia','Georgia','Germany','Ghana','Greece','Guatemala','Guinea','Haiti',
  'Honduras','Hungary','Iceland','India','Indonesia','Iran','Iraq','Ireland','Israel','Italy','Jamaica',
  'Japan','Jordan','Kazakhstan','Kenya','Kuwait','Kyrgyzstan','Laos','Latvia','Lebanon','Libya','Lithuania',
  'Luxembourg','Madagascar','Malawi','Malaysia','Maldives','Mali','Malta','Mauritania','Mauritius','Mexico',
  'Moldova','Monaco','Mongolia','Montenegro','Morocco','Mozambique','Myanmar','Namibia','Nepal','Netherlands',
  'New Zealand','Nicaragua','Niger','Nigeria','North Korea','Norway','Oman','Pakistan','Palestine','Panama',
  'Papua New Guinea','Paraguay','Peru','Philippines','Poland','Portugal','Qatar','Romania','Russia','Rwanda',
  'Saudi Arabia','Senegal','Serbia','Sierra Leone','Singapore','Slovakia','Slovenia','Somalia','South Africa',
  'South Korea','Spain','Sri Lanka','Sudan','Sweden','Switzerland','Syria','Taiwan','Tajikistan','Tanzania',
  'Thailand','Togo','Tunisia','Turkey','Turkmenistan','Uganda','Ukraine','United Arab Emirates','United Kingdom',
  'United States','Uruguay','Uzbekistan','Venezuela','Vietnam','Yemen','Zambia','Zimbabwe'
];

const QUESTIONS = [
  { key: 'appearance', icon: '', title: 'How does it look?', desc: 'Rate the appearance, color and visual appeal', type: 'star', commentKey: 'appearance_comment' },
  { key: 'aroma', icon: '', title: 'How does it smell?', desc: 'Rate the aroma and fragrance', type: 'star' },
  { key: 'texture', icon: '', title: 'How is the texture?', desc: 'Rate the crunch, chew and mouthfeel', type: 'star' },
  { key: 'taste', icon: '', title: 'How does it taste?', desc: 'Rate the flavor, balance and taste experience', type: 'emoji', commentKey: 'taste_comment' },
  { key: 'value', icon: '', title: 'Is it worth the price?', desc: 'Rate the value for money', type: 'star' },
  { key: 'would_buy', icon: '', title: 'Would you buy this?', desc: 'Tell us your purchase intention', type: 'buy', commentKey: 'overall_comment' },
];

const EMOJIS = [
  { val: 1, emoji: '😖', label: 'Terrible' },
  { val: 2, emoji: '😕', label: 'Bad' },
  { val: 3, emoji: '😐', label: 'OK' },
  { val: 4, emoji: '😋', label: 'Good' },
  { val: 5, emoji: '🤩', label: 'Amazing' },
];

function CountrySelect({ value, onChange }) {
  const [search, setSearch] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const filtered = COUNTRIES.filter(c => c.toLowerCase().includes(search.toLowerCase()));
  return (
    <div style={{ position: 'relative' }}>
      <div onClick={() => setOpen(o => !o)} style={{ padding: '10px 14px', border: '1.5px solid #eee', borderRadius: 10, fontSize: 14, cursor: 'pointer', background: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: value ? '#333' : '#aaa' }}>{value || 'Select nationality...'}</span>
        <span style={{ color: '#aaa' }}>▾</span>
      </div>
      {open && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1.5px solid #eee', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 100, maxHeight: 220, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '8px 12px', borderBottom: '1px solid #eee' }}>
            <input autoFocus value={search} onChange={e => setSearch(e.target.value)} placeholder="Search country..." style={{ width: '100%', border: 'none', outline: 'none', fontSize: 13 }} />
          </div>
          <div style={{ overflowY: 'auto', maxHeight: 170 }}>
            {filtered.map(c => (
              <div key={c} onMouseDown={() => { onChange(c); setOpen(false); setSearch(''); }}
                style={{ padding: '8px 14px', cursor: 'pointer', fontSize: 13, background: value === c ? '#f3e8ff' : 'white' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f9f3f8'}
                onMouseLeave={e => e.currentTarget.style.background = value === c ? '#f3e8ff' : 'white'}>
                {c}
              </div>
            ))}
            {filtered.length === 0 && <div style={{ padding: '12px 14px', color: '#aaa', fontSize: 13 }}>No results</div>}
          </div>
        </div>
      )}
    </div>
  );
}

export default function ConsumerReview() {
  const { session_code } = useParams();
  const [session, setSession] = useState(null);
  const [error, setError] = useState(null);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [step, setStep] = useState(-1);
  const [profile, setProfile] = useState({ respondent_name: '', nationality: '', age_group: '', snack_frequency: '', where_tried: '' });
  const [scores, setScores] = useState({ appearance: 0, aroma: 0, texture: 0, taste: 0, value: 0, would_buy: '', appearance_comment: '', taste_comment: '', overall_comment: '' });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // Check if already submitted for this session from this device
    const key = 'submitted_' + session_code;
    if (localStorage.getItem(key)) { setAlreadySubmitted(true); }

    fetch(BASE + '/taste/public/' + session_code)
      .then(r => r.json())
      .then(d => { if (d.error) setError(d.error); else setSession(d); })
      .catch(() => setError('Unable to load session'));
  }, [session_code]);

  const submit = async () => {
    setSubmitting(true);
    try {
      await fetch(BASE + '/taste/consumer-response', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: session.id,
          ...profile,
          appearance_score: scores.appearance,
          aroma_score: scores.aroma,
          texture_score: scores.texture,
          taste_score: scores.taste,
          value_score: scores.value,
          would_buy: scores.would_buy,
          appearance_comment: scores.appearance_comment,
          taste_comment: scores.taste_comment,
          overall_comment: scores.overall_comment,
        })
      });
      localStorage.setItem('submitted_' + session_code, '1');
      setStep(7);
    } catch(e) { alert('Failed to submit. Please try again.'); }
    setSubmitting(false);
  };

  const avgScore = () => {
    const vals = [scores.appearance, scores.aroma, scores.texture, scores.taste, scores.value].filter(v => v > 0);
    return vals.length ? (vals.reduce((a,b) => a+b, 0) / vals.length).toFixed(1) : '—';
  };

  const S = { minHeight: '100vh', background: 'linear-gradient(160deg,#7B2D6B 0%,#4a1a42 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: '-apple-system,Arial,sans-serif' };
  const CARD = { background: 'white', borderRadius: 20, padding: 28, width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' };

  if (error) return <div style={S}><div style={CARD}><div style={{ textAlign: 'center', padding: 20 }}><div style={{ fontSize: 40 }}>❌</div><div style={{ fontSize: 16, fontWeight: 700, marginTop: 12 }}>Session Not Found</div><div style={{ fontSize: 13, color: '#888', marginTop: 6 }}>{error}</div></div></div></div>;

  if (alreadySubmitted && step !== 7) return (
    <div style={S}>
      <div style={CARD}>
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <div style={{ fontSize: 50, marginBottom: 12 }}>✅</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#333', marginBottom: 8 }}>Already Submitted</div>
          <div style={{ fontSize: 13, color: '#888' }}>You have already shared your feedback for this session. Thank you!</div>
          <div style={{ marginTop: 20, fontSize: 11, color: '#aaa' }}>Powered by BGH × Tasting Folks</div>
        </div>
      </div>
    </div>
  );

  if (!session) return <div style={S}><div style={{ color: 'white', fontSize: 14 }}>Loading...</div></div>;

  if (step === -1) return (
    <div style={{ ...S, background: "linear-gradient(135deg, #7B2D6B 0%, #3a0a3a 40%, #1a0828 80%, #0a0818 100%)" }}>
      <style>{}</style>
      {[...Array(10)].map((_,i) => (<div key={i} className="tf-bubble" style={{width:(8+(i*7)%18)+"px",height:(8+(i*7)%18)+"px",left:(i*9+2)+"%",background:i%3===0?"rgba(180,80,200,.25)":i%3===1?"rgba(232,84,26,.2)":"rgba(255,255,255,.1)",animationDuration:(3.5+(i*.6)%3.5)+"s",animationDelay:(i*.45)+"s",bottom:"-20px"}} />))}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,width:"100%",maxWidth:420,position:"relative",zIndex:2}}>
        <div style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,0.5)",letterSpacing:"0.15em",textTransform:"uppercase"}}>Tasting Folks</div>
        <div style={{background:"rgba(255,255,255,0.12)",padding:"4px 10px",borderRadius:7,fontSize:11,fontWeight:800,color:"rgba(255,255,255,0.7)"}}>BGH</div>
      </div>
      <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",textAlign:"center",position:"relative",zIndex:2,paddingBottom:16,width:"100%",maxWidth:420}}>
        <div style={{width:120,height:120,borderRadius:"50%",background:"rgba(255,255,255,0.12)",border:"1.5px solid rgba(255,255,255,0.25)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16,padding:10}}>
          <img src="/logo.png" alt="TF" style={{width:96,height:96,borderRadius:"50%",objectFit:"contain"}} onError={e=>e.target.style.display="none"} />
        </div>
        <div style={{fontSize:9,color:"rgba(255,255,255,0.4)",textTransform:"uppercase",letterSpacing:"0.2em",marginBottom:8}}>You are tasting</div>
        <div style={{fontSize:22,fontWeight:900,color:"white",marginBottom:6,lineHeight:1.2}}>{session.product_name}</div>
        <div style={{fontSize:11,color:"rgba(255,255,255,0.45)",marginBottom:24}}>Your opinion shapes this product</div>
        <div style={{display:"flex",gap:0,background:"rgba(255,255,255,0.07)",borderRadius:12,overflow:"hidden",marginBottom:24,width:"100%"}}>
          {[["3","steps"],["2","minutes"],["100%","anonymous"]].map(([val,lbl],i) => (
            <div key={i} style={{flex:1,textAlign:"center",padding:"12px 8px",borderRight:i<2?"1px solid rgba(255,255,255,0.08)":"none"}}>
              <div style={{fontSize:16,fontWeight:800,color:"#E8541A"}}>{val}</div>
              <div style={{fontSize:9,color:"rgba(255,255,255,0.4)",marginTop:2}}>{lbl}</div>
            </div>
          ))}
        </div>
      </div>
      <div style={{position:"relative",zIndex:2,width:"100%",maxWidth:420}}>
        <button style={{background:"white",color:"#7B2D6B",border:"none",borderRadius:14,padding:18,width:"100%",fontSize:17,fontWeight:800,cursor:"pointer"}} onClick={()=>setStep(0)}>Start Tasting</button>
        <div style={{textAlign:"center",fontSize:10,color:"rgba(255,255,255,0.25)",marginTop:8}}>2 minutes · Anonymous · Your voice matters</div>
      </div>
    </div>
  );

  if (step === 0) return (
    <div style={{ ...S, background: 'linear-gradient(135deg, #7B2D6B 0%, #3a0a3a 40%, #1a0828 80%, #0a0818 100%)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, width: '100%', maxWidth: 420 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', letterSpacing: '0.15em', textTransform: 'uppercase' }}>Profile</div>
        <div style={{ background: 'rgba(255,255,255,0.12)', padding: '4px 10px', borderRadius: 7, fontSize: 11, fontWeight: 800, color: 'rgba(255,255,255,0.7)' }}>BGH</div>
      </div>
      <div style={{ ...CARD, borderRadius: 20, border: 'none', padding: 22 }}>
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 16, fontWeight: 800, color: '#1a1a1a', marginBottom: 4 }}>Tell us about yourself</div>
          <div style={{ fontSize: 12, color: '#bbb' }}>Optional — helps us understand our audience</div>
        </div>
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 10, color: '#aaa', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 6 }}>Your Name</div>
          <input type="text" value={profile.respondent_name} onChange={e => setProfile({...profile, respondent_name: e.target.value})} placeholder="Optional"
            style={{ width: '100%', padding: '12px 14px', border: '1.5px solid #eee', borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }} />
        </div>
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 10, color: '#aaa', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 6 }}>Nationality</div>
          <CountrySelect value={profile.nationality} onChange={v => setProfile({...profile, nationality: v})} />
        </div>
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 10, color: '#aaa', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 8 }}>Age Group</div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {['18-25', '26-35', '36-45', '46+'].map(a => (
              <button key={a} onClick={() => setProfile({...profile, age_group: a})}
                style={{ padding: '8px 16px', borderRadius: 20, border: '1.5px solid', borderColor: profile.age_group === a ? '#7B2D6B' : '#eee', background: profile.age_group === a ? '#7B2D6B' : 'white', color: profile.age_group === a ? 'white' : '#555', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>{a}</button>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 10, color: '#aaa', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 8 }}>How often do you snack?</div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {['Daily', 'Weekly', 'Occasionally'].map(f => (
              <button key={f} onClick={() => setProfile({...profile, snack_frequency: f})}
                style={{ padding: '8px 16px', borderRadius: 20, border: '1.5px solid', borderColor: profile.snack_frequency === f ? '#E8541A' : '#eee', background: profile.snack_frequency === f ? '#E8541A' : 'white', color: profile.snack_frequency === f ? 'white' : '#555', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>{f}</button>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: 22 }}>
          <div style={{ fontSize: 10, color: '#aaa', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 8 }}>Where did you try this?</div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {['Supermarket', 'Event', 'Gift', 'Office', 'Online'].map(w => (
              <button key={w} onClick={() => setProfile({...profile, where_tried: w})}
                style={{ padding: '8px 14px', borderRadius: 20, border: '1.5px solid', borderColor: profile.where_tried === w ? '#7B2D6B' : '#eee', background: profile.where_tried === w ? '#7B2D6B' : 'white', color: profile.where_tried === w ? 'white' : '#555', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{w}</button>
            ))}
          </div>
        </div>
        <button onClick={() => setStep(1)}
          style={{ width: '100%', background: 'linear-gradient(135deg, #7B2D6B, #E8541A)', color: 'white', border: 'none', borderRadius: 12, padding: 16, fontSize: 16, fontWeight: 800, cursor: 'pointer' }}>Continue</button>
        <div style={{ textAlign: 'center', fontSize: 11, color: '#ccc', marginTop: 8 }}>All fields optional</div>
      </div>
    </div>
  );

  if (step === 7) return (
    <div style={{ ...S, background: 'linear-gradient(135deg, #7B2D6B 0%, #3a0a3a 40%, #1a0828 80%, #0a0818 100%)' }}>
      <div style={{ ...CARD, borderRadius: 20, border: 'none', padding: 28, textAlign: 'center' }}>
        <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'linear-gradient(135deg, #f3e8ff, #fce4d6)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', border: '2px solid rgba(123,45,107,0.15)' }}>
          <img src="/logo.png" alt="TF" style={{ width: 60, height: 60, borderRadius: '50%', objectFit: 'contain' }} onError={e => e.target.style.display='none'} />
        </div>
        <div style={{ fontSize: 24, fontWeight: 900, color: '#1a1a1a', marginBottom: 8 }}>Thank You!</div>
        <div style={{ fontSize: 13, color: '#888', marginBottom: 24, lineHeight: 1.6 }}>Your feedback helps us create better products. We truly appreciate your time.</div>
        <div style={{ background: '#f9f3f8', borderRadius: 14, padding: 20, marginBottom: 20 }}>
          <div style={{ fontSize: 10, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 14, fontWeight: 700 }}>Your Summary</div>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#7B2D6B' }}>{avgScore()}</div>
              <div style={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 2 }}>Overall</div>
            </div>
            <div style={{ width: 1, background: '#eee' }} />
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 24, fontWeight: 800, color: scores.taste >= 4 ? '#2e7d32' : scores.taste >= 3 ? '#e67e00' : '#c62828' }}>{scores.taste || '-'}</div>
              <div style={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 2 }}>Taste</div>
            </div>
            <div style={{ width: 1, background: '#eee' }} />
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 13, fontWeight: 800, color: scores.would_buy === 'yes' ? '#2e7d32' : scores.would_buy === 'maybe' ? '#e67e00' : '#c62828', marginTop: 4 }}>
                {scores.would_buy === 'yes' ? 'YES' : scores.would_buy === 'maybe' ? 'MAYBE' : 'NO'}
              </div>
              <div style={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 2 }}>Would Buy</div>
            </div>
          </div>
        </div>
        <div style={{ fontSize: 11, color: '#ccc' }}>Powered by BGH x Tasting Folks</div>
      </div>
    </div>
  );

  const qIdx = step - 1;
  const q = QUESTIONS[qIdx];
  const progress = (step / QUESTIONS.length) * 100;

  return (
    <div style={{ ...S, background: 'linear-gradient(135deg, #7B2D6B 0%, #3a0a3a 40%, #1a0828 80%, #0a0818 100%)' }}>
      <div style={{ width: '100%', maxWidth: 420, marginBottom: 12 }}>
        <div style={{ height: 4, background: 'rgba(255,255,255,0.2)', borderRadius: 2 }}>
          <div style={{ height: '100%', background: '#E8541A', borderRadius: 2, width: progress + '%', transition: 'width 0.3s' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6 }}>
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)' }}>Question {step} of {QUESTIONS.length}</span>
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)' }}>{session.product_name}</span>
        </div>
      </div>
      <div style={CARD}>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>{q.icon}</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#333', marginBottom: 6 }}>{q.title}</div>
          <div style={{ fontSize: 12, color: '#888' }}>{q.desc}</div>
        </div>

        {q.type === 'star' && (
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginBottom: 8 }}>
              {[1,2,3,4,5].map(v => (
                <span key={v} onClick={() => setScores({...scores, [q.key]: v})}
                  style={{ fontSize: 38, cursor: 'pointer', color: scores[q.key] >= v ? '#E8541A' : '#ddd', transition: 'color 0.15s', lineHeight: 1 }}>★</span>
              ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#aaa', padding: '0 4px' }}>
              <span>Poor</span><span>Excellent</span>
            </div>
          </div>
        )}

        {q.type === 'emoji' && (
          <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: 16 }}>
            {EMOJIS.map(e => (
              <div key={e.val} onClick={() => setScores({...scores, [q.key]: e.val})}
                style={{ textAlign: 'center', cursor: 'pointer', padding: '8px 6px', borderRadius: 12, background: scores[q.key] === e.val ? '#f3e8ff' : 'transparent', border: `2px solid ${scores[q.key] === e.val ? '#7B2D6B' : 'transparent'}` }}>
                <div style={{ fontSize: 32 }}>{e.emoji}</div>
                <div style={{ fontSize: 9, color: '#888', marginTop: 4 }}>{e.label}</div>
              </div>
            ))}
          </div>
        )}

        {q.type === 'buy' && (
          <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            {[['yes', '✓ Yes!', '#e8f5e9', '#2e7d32'], ['maybe', '🤔 Maybe', '#fff3e0', '#e67e00'], ['no', '✗ No', '#fce8e6', '#c62828']].map(([val, lbl, bg, col]) => (
              <button key={val} onClick={() => setScores({...scores, would_buy: val})}
                style={{ flex: 1, padding: 12, borderRadius: 10, border: `2px solid ${scores.would_buy === val ? col : '#eee'}`, background: scores.would_buy === val ? bg : 'white', color: col, fontWeight: 700, cursor: 'pointer', fontSize: 14 }}>{lbl}</button>
            ))}
          </div>
        )}

        {q.commentKey && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 11, color: '#aaa', marginBottom: 6 }}>Any comments? (optional)</div>
            <textarea value={scores[q.commentKey]} onChange={e => setScores({...scores, [q.commentKey]: e.target.value})} rows={2}
              style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #eee', borderRadius: 10, fontSize: 13, resize: 'none', outline: 'none', boxSizing: 'border-box' }} placeholder="Tell us more..." />
          </div>
        )}

        <div style={{ display: 'flex', gap: 10 }}>
          {step > 1 && <button onClick={() => setStep(s => s-1)} style={{ flex: 1, padding: 14, background: '#f3e8ff', color: '#7B2D6B', border: 'none', borderRadius: 12, fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>← Back</button>}
          <button onClick={() => {
            const val = q.key === 'would_buy' ? scores.would_buy : scores[q.key];
            if (!val) return alert('Please make a selection');
            if (step === QUESTIONS.length) submit();
            else setStep(s => s+1);
          }}
            style={{ flex: 2, padding: 14, background: '#7B2D6B', color: 'white', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: 'pointer' }} disabled={submitting}>
            {step === QUESTIONS.length ? (submitting ? 'Submitting...' : '✓ Submit') : 'Next →'}
          </button>
        </div>
      </div>
    </div>
  );
}
